import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-reporting';
import { Spinner } from '@trello/nachos/spinner';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { ViewSwitcherProps } from './ViewSwitcher';
export const LazyViewSwitcher: FunctionComponent<ViewSwitcherProps> = (
  props,
) => {
  const ViewSwitcher = useLazyComponent(
    () => import(/* webpackChunkName: "view-switcher" */ './ViewSwitcher'),
    { namedImport: 'ViewSwitcher' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={<Spinner />}>
        <ViewSwitcher {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
